interface ConsumableCardProps {
    type: 'fuel' | 'oil' | 'nitro' | 'tyre';
    text: string;
    onClick?: () => void;
}

export const ConsumableCard = ({ type, text, onClick }: ConsumableCardProps) => {
    return (
        <div className="consumable-card" onClick={onClick}>
            <img 
                className="consumable-icon"
                src={`/icons/64px/${type}.png`} 
                alt={type}
            />
            <p>{text}</p>
        </div>
    );
};